import image1 from '../assets/aarav.png';
import image2 from '../assets/rushi2.png';
import image3 from '../assets/rk.png';
import image4 from '../assets/sunny.png';

export const testimonialsData = [
  {
    image: image1,
    review:
      'I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!',
    name: 'Aarav',
    status: 'CUSTOMER ',
  },
  {
    image: image2,
    review:
      'The Beast Factory Gym is a trainers paradise, offering top-notch equipment and an inspiring atmosphere for ultimate fitness transformations.',
    name: '𝐑𝐮𝐬𝐡𝐢',
    status: 'COACH',
  },
  {
    image: image3,
    review:
      'It was difficult to find a good gym with all the equipment i need to training my students. Found it!',
    name: 'rahul',
    status: 'COACH',
  },
  {
    image: image4,
    review:
      'The Beast Factory Gym delivers an unmatched fitness experience, transforming my body and boosting my confidence like never before.',
    name: 'sunny',
    status: 'CUSTOMER',
  },
];
